export const SCREENING_IDS = ['bipolar', 'ptsd', 'social-anxiety', 'eating'];
export const SCREENINGS = [
    {
        id: 'bipolar',
        title: 'Mood highs',
        minutes: 2,
        specialization: 'bipolar',
        directorySlug: 'bipolar',
        scale: 'yesno',
        intro: 'This asks about stretches of several days when your energy, sleep, or spending felt unusually high. It is a screen, not a diagnosis.',
        questions: [
            {
                prompt: 'Have you had several days when you needed much less sleep and still felt full of energy?',
            },
            {
                prompt: 'Have thoughts raced, or have you talked much more than usual, for days at a time?',
            },
            {
                prompt: 'Have you started big plans, spent more than you meant to, or taken risks you later regretted?',
            },
            { prompt: 'Has your mood felt unusually high, irritable, or both, for several days?' },
            { prompt: 'Did people close to you notice that you were not your usual self?' },
            { prompt: 'Did that stretch get in the way of work, study, or relationships?' },
        ],
    },
    {
        id: 'ptsd',
        title: 'After a frightening event',
        minutes: 2,
        specialization: 'trauma_ptsd',
        directorySlug: 'trauma',
        scale: 'yesno',
        intro: 'Adapted from the PC-PTSD-5, a public screen from the U.S. National Center for PTSD. Think of a frightening or traumatic event. In the past month, have you:',
        questions: [
            { prompt: 'Had nightmares about it, or thought about it when you did not want to?' },
            { prompt: 'Tried hard not to think about it, or avoided reminders?' },
            { prompt: 'Been constantly on guard, watchful, or easily startled?' },
            { prompt: 'Felt numb or detached from people, activities, or your surroundings?' },
            {
                prompt: 'Felt guilty, or unable to stop blaming yourself or others for the event or what followed?',
            },
        ],
    },
    {
        id: 'social-anxiety',
        title: 'Being around people',
        minutes: 2,
        specialization: 'anxiety',
        directorySlug: 'anxiety',
        scale: 'frequency',
        intro: 'Over the last two weeks, how often has being seen, judged, or put on the spot got in the way? This is a screen, not a diagnosis.',
        questions: [
            { prompt: 'I avoided speaking because I was afraid of looking foolish.' },
            { prompt: 'I skipped meals, meetings, or gatherings so I would not be noticed.' },
            { prompt: 'My heart raced or my mind went blank when attention turned to me.' },
            { prompt: 'I replayed conversations afterwards and felt ashamed.' },
            { prompt: 'Fear of embarrassment kept me from something I wanted to do.' },
            { prompt: 'I needed a lot of reassurance before I could be around people.' },
        ],
    },
    {
        id: 'eating',
        title: 'Food and body',
        minutes: 1,
        specialization: 'eating_disorders',
        directorySlug: 'eating',
        scale: 'yesno',
        intro: 'Five yes-or-no questions about eating and body image. Two or more “yes” answers are a reason to talk with a clinician. This is a screen, not a diagnosis.',
        questions: [
            { prompt: 'Have you made yourself vomit because you felt uncomfortably full?' },
            { prompt: 'Do you worry you have lost control over how much you eat?' },
            { prompt: 'Have you lost more than about 6 kilograms in the last three months?' },
            { prompt: 'Do you believe you are fat when other people say you are too thin?' },
            { prompt: 'Would you say that food dominates your life?' },
        ],
    },
];
export function getScreening(id) {
    return SCREENINGS.find((item) => item.id === id);
}
export function scoreScreening(screening, answers) {
    const score = answers.reduce((sum, value) => sum + value, 0);
    if (screening.scale === 'yesno') {
        const threshold = screening.id === 'bipolar' ? 4 : screening.id === 'ptsd' ? 3 : 2;
        const suggestClinician = score >= threshold;
        return {
            score,
            max: screening.questions.length,
            suggestClinician,
            summary: suggestClinician
                ? 'Your answers suggest talking with a clinician. This screen cannot tell you what is going on.'
                : 'Nothing here stands out strongly. If life still feels hard, a conversation can still help.',
        };
    }
    const max = screening.questions.length * 3;
    const suggestClinician = score >= 8;
    return {
        score,
        max,
        suggestClinician,
        summary: suggestClinician
            ? 'Being around people seems to be costing you. A clinician who works with anxiety can help you sort out next steps.'
            : 'These answers are on the quieter side. You can still book if being around people is wearing you down.',
    };
}
//# sourceMappingURL=screenings.js.map